export enum GeoLocationSections {
  USER_LOCATION = 'geolocation-user',
}
